import { NavigationProvider } from "@platform/navigation-control";
import { ReactElement, ReactNode } from "react";
import { Link, useNavigate } from "react-router";

import { ROUTE_NAMES } from "../constants";
import { APP_ROUTES, APP_ROUTES_V2 } from "../constants/router";

const AppNavigationProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const navigate = useNavigate();
  const routes = [
    "/",
    ROUTE_NAMES.LOGIN,
    "centro",
    ROUTE_NAMES.RESET_PASSWORD,
    ROUTE_NAMES.ONBOARDING,
    ...[...APP_ROUTES, ...APP_ROUTES_V2].map((route) => route.path),
  ];

  return (
    <NavigationProvider routes={routes} RouterLink={Link} navigate={navigate}>
      {children}
    </NavigationProvider>
  );
};

export default AppNavigationProvider;
